// Wait until Google Maps is loaded AND its base classes are actually available
// before running the callback. Callers define classes at module-load time
// (e.g. `class extends google.maps.MVCObject` / `OverlayView`), so it is not
// enough for `google.maps` to merely exist: with the async bootstrap loader
// (loading=async) `google.maps` is created as a partial stub before its classes
// are populated, and extending an undefined base throws "Super expression must
// either be null or a function". Gate on the base classes themselves.
export function waitForGoogleMaps(callback) {
  const maps = window.google && window.google.maps;
  if (maps && typeof maps.MVCObject === 'function' && typeof maps.OverlayView === 'function') {
    callback();
  } else {
    setTimeout(() => waitForGoogleMaps(callback), 50);
  }
}
